export default [
    {
        path: "/agrupadores-acciones",
        name: "agrupadores-acciones",
        component: () =>
            import(/* webpackChunkName: "estructuraStepper" */ "./index.vue"),
    },
];